




















































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { Company, Office } from "@/api/company-api";
import VStaffTable, { StaffTableItem } from "@/components/VStaffTable.vue";
import VSearchBar from "@/components/VSearchBar.vue";
import { getUserServices, addStorageLimitService } from "@/api/service-api";

@Component({
  components: {
    VStaffTable,
    VSearchBar
  }
})
export default class CompanyShow extends Vue {
  @Prop({ required: true }) company!: Company;
  @Prop({ required: true }) office!: Office;
  @Prop({ default: () => [] }) staffItems!: StaffTableItem[];
  @Prop({ type: Boolean, default: false }) noCompany!: boolean;
  @Prop({ type: Boolean, default: false }) noInvite!: boolean;
  query: string = "";

  formData = {
    increaseStorage: 10
  };

  isButtonDisabled = false;

  storage = {
    used: 0,
    limit: 0
  };

  messageStorage = "";

  isUserService = false;

  get items() {
    return this.staffItems;
  }

  async onSubmit() {
    this.isButtonDisabled = true;
    await addStorageLimitService(this.formData.increaseStorage);
    this.isButtonDisabled = false;
    this.$bvModal.hide("storage-modal");
    this.service();
  }

  select(id: number) {
    this.$emit("selectStaff", id);
  }

  invite(id: number) {
    this.$emit("inviteStaff", id);
  }
  search(query: string) {
    this.$emit("search", query);
  }

  getPrecent(storage_used: number, storage_limit: number) {
    let percent = (storage_used / storage_limit) * 100;

    if (percent > 0 && percent < 1) {
      percent = 1;
    } else if (percent >= 99 && percent < 100) {
      percent = 99;
    } else if (percent <= 0) {
      percent = 0;
    } else if (percent >= 100) {
      percent = 100;
    } else {
      return percent.toFixed(2);
    }

    return percent;
  }

  convertBytesFromGB(data: number) {
    let number = data / 1024 / 1024 / 1024;
    let result: any = 0;

    if (Number(number.toFixed(4)) > 0 && Number(number.toFixed(4)) <= 0.0049) {
      result = "0.00";
    } else if (Number(number.toFixed(4)) <= 0) {
      result = 0;
    } else {
      result = Number(Math.round(number * 1000) / 1000).toFixed(2);
    }

    return result + " GB";
  }

  showMessage(storage_used: number, storage_limit: number) {
    const percent = Number(this.getPrecent(storage_used, storage_limit));
    if (percent >= 90 && percent < 100) {
      this.messageStorage =
        "ストレージ残量が少なくなりました、容量を追加してください。ストレージがいっぱいになると、写真等の保存ができなくなります。";
      return true;
    }
    if (percent >= 100) {
      this.messageStorage =
        "ストレージ容量がいっぱいになりました。追加の容量を購入するか、不要なファイルを削除してください。";
      return true;
    }

    return false;
  }

  async service() {
    await getUserServices().then(res => {
      res.forEach(service => {
        if (service.id === this.$store.state.serviceId)
          this.storage = {
            used: Number(service.storage_used),
            limit: service.storage_limit
          };

        if (
          (service.name === this.company.name &&
            this.company.family === true) ||
          this.company.isFirstCompany
        ) {
          this.isUserService = true;
        }
      });
    });

    return;
  }

  created() {
    this.service();
  }

  show() {
    (this.$refs.modal as any).show();
  }
}
